import moment from 'moment';
import { REFERRAL_CLOSE_REQUEST, REFERRAL_CLOSE_SUCCESS, REFERRAL_CLOSE_FAILURE } from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import globals from '../../../globals/communityGlobals';

export function closeReferral(referralData) {
  return {
    types: [REFERRAL_CLOSE_REQUEST, REFERRAL_CLOSE_SUCCESS, REFERRAL_CLOSE_FAILURE],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: Object.assign({}, referralData, {
        dateClosed: moment(referralData.dateClosed)
          .utcOffset(0, true)
          .format(globals.dateFormats.localApiFormat),
      }),
      path: 'v1/command/CloseReferral',
    }),
  };
}
